"use client";

import { BreadcrumbSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import BreadcrumbSectionGenerated, {
  BreadcrumbSectionGeneratedProps,
} from "../Sections/_generated/BreadcrumbSection.generated";
import { buildGeneratedSectionProps } from "./generated-section-renderer";

const GeneratedBreadcrumbSection: FC<BreadcrumbSectionProps> = (props) => {
  const defaults =
    buildGeneratedSectionProps<BreadcrumbSectionGeneratedProps>(
      "BreadcrumbSection",
    );
  const title = props.setting.Title ?? defaults.divDiv0Div0Div0Nav0H20H2Text;
  const subtitle = props.setting.Subtitle ?? title;

  return (
    <BreadcrumbSectionGenerated
      {...defaults}
      divDiv0Div0Div0Nav0H20H2Text={title}
      divDiv0Div0Div0Nav0Ol0Li1LiText={subtitle}
      divDiv0Div0Div0Nav0Ol0Li0Link0LinkHref="/"
    />
  );
};

export default GeneratedBreadcrumbSection;
